import type {
	AdminUserDetail,
	GuestUserRow,
	ListGuestUsersParams,
	SetDiscountStateBody,
} from "@/features/users/api/types";
import { toAdminSearchParams } from "@/shared/api/admin-list";
import { api } from "@/shared/api/client";
import type { InfinityPage } from "@/shared/api/types";

export async function listGuestUsers(
	params: ListGuestUsersParams = {},
): Promise<InfinityPage<GuestUserRow>> {
	const searchParams = toAdminSearchParams({
		...params,
		sort: params.sort ?? "createdAt",
		order: params.order ?? "DESC",
	});
	if (params.deletionRequested) {
		searchParams.set("deletionRequested", "true");
	}
	return api.get("admin/users", { searchParams }).json();
}

export async function deleteGuestUser(id: string): Promise<void> {
	await api.delete(`admin/users/${id}`);
}

export async function getAdminUser(id: string): Promise<AdminUserDetail> {
	return api.get(`admin/users/${id}`).json();
}

export type AdminUserCard = {
	cardId: string;
	cardUrl: string;
};

export async function getAdminUserCard(id: string): Promise<AdminUserCard> {
	return api.get(`admin/users/${id}/card`).json();
}

export async function renameAdminUser(
	id: string,
	body: { name: string; surname: string },
): Promise<AdminUserDetail> {
	return api.patch(`admin/users/${id}`, { json: body }).json();
}

export async function setAdminUserDiscountState(
	id: string,
	body: SetDiscountStateBody,
): Promise<AdminUserDetail> {
	return api.patch(`admin/users/${id}/discounts/state`, { json: body }).json();
}

export const guestUserKeys = {
	all: ["admin-users"] as const,
	list: (params: ListGuestUsersParams) =>
		["admin-users", "list", params] as const,
	detail: (id: string) => ["admin-users", "detail", id] as const,
	card: (id: string) => ["admin-users", "card", id] as const,
};
